<div class="flex sm:h-full" [ngClass]="{ 'h-[920px] flex-col': isPreview(), 'h-[590px] w-full gap-4 sm:flex-col': !isPreview() }">
    <div
        class="md:p-6m flex flex-col gap-4 rounded-[10px] p-6 pb-5 sm:!gap-4 sm:px-4 md:gap-0"
        [ngClass]="{
            'bg-malou-pink--light': aggregatedScoreRating() === DiagnosticRating.BAD,
            'bg-malou-yellow--light': aggregatedScoreRating() === DiagnosticRating.AVERAGE,
            'bg-malou-green--light': aggregatedScoreRating() === DiagnosticRating.GOOD,
            'mb-3': isPreview(),
            '!mb-5': isPreview() && !isPhoneScreen() && (isExactlyXRestaurants | applyPure: 2),
            'w-2/5 sm:w-full': !isPreview(),
        }">
        <ng-container [ngTemplateOutlet]="scoreTemplate"></ng-container>
        @if (isPreview()) {
            <ng-container [ngTemplateOutlet]="scoreDetailsHeaderTemplate"></ng-container>
        }
    </div>

    <div
        class="flex h-full flex-col justify-between sm:gap-4"
        [ngClass]="{
            '!w-full': !isPreview(),
            'gap-2': isPreview() && (isExactlyXRestaurants | applyPure: 2),
        }">
        @for (restaurantDiagnosticData of restaurantsDiagnosticsData(); let i = $index; track restaurantDiagnosticData.id) {
            <ng-container
                [ngTemplateOutlet]="scoreDetailsTemplate"
                [ngTemplateOutletContext]="{
                    restaurantDiagnosticData,
                }"></ng-container>
        }
    </div>
</div>

<ng-template #scoreTemplate>
    <div
        class="flex w-full gap-3 sm:!gap-4 md:gap-0"
        [ngClass]="{
            'w-[30%] !flex-row !justify-between sm:!flex-col': isPreview(),
            '!h-full flex-col items-center !gap-12': !isPreview(),
        }">
        <div class="flex justify-center text-malou-text-title">
            <div class="malou-text-50--bold md:malou-text-20--bold mt-3 font-passion-one uppercase md:mt-0">
                <span class="relative block">
                    <span
                        class="flex flex-col sm:flex-row sm:gap-2"
                        [ngClass]="{
                            'leading-none': isPreview(),
                            'leading-[1.3]': !isPreview(),
                        }"
                        [innerHTML]="'maloupe.aggregated_diagnostic_score.title' | translate"></span>
                    <mat-icon
                        class="absolute right-[-10px] top-[-20px] !h-10 !w-10 shrink-0 text-malou-text-title md:bottom-2.5 md:right-[-18px] md:!inline-block md:!h-7 md:!w-7"
                        [svgIcon]="SvgIcon.SPARKLES"></mat-icon>
                </span>
            </div>
        </div>

        <ng-container
            [ngTemplateOutlet]="scoreRatingTemplate"
            [ngTemplateOutletContext]="{
                score: aggregatedScore(),
                scoreRating: aggregatedScoreRating(),
                scoreGaugeImage: aggregatedScoreGaugeImage(),
                isRestaurantScore: false,
            }"></ng-container>
    </div>
</ng-template>

<ng-template let-restaurantDiagnosticData="restaurantDiagnosticData" #scoreDetailsTemplate>
    <div
        class="flex w-full flex-col gap-2 rounded-[10px] border-l-[12px] px-6.5 py-5 md:gap-y-5 md:p-5"
        [ngClass]="{
            'border-malou-pink bg-malou-pink--light/30': restaurantDiagnosticData.totalScoreRating === DiagnosticRating.BAD,
            'border-malou-yellow bg-malou-yellow--light/30': restaurantDiagnosticData.totalScoreRating === DiagnosticRating.AVERAGE,
            'border-malou-green bg-malou-green--light/30': restaurantDiagnosticData.totalScoreRating === DiagnosticRating.GOOD,
            '!py-7.5': (isExactlyXRestaurants | applyPure: 4) && !isPhoneScreen(),
            '!py-7': (isExactlyXRestaurants | applyPure: 2) && !isPreview() && !isPhoneScreen(),
        }">
        <ng-container [ngTemplateOutlet]="restaurantScoreTemplate" [ngTemplateOutletContext]="{ restaurantDiagnosticData }"></ng-container>
        @if (restaurantsDiagnosticsData().length <= MAXIMUM_NUMBER_OF_RESTAURANTS_TO_SHOW_DETAILS) {
            @let restaurantSortedScoreCriterions = getRestaurantSortedScoreCriterions | applyPure: restaurantDiagnosticData.id;
            @for (scoreCriteria of restaurantSortedScoreCriterions; track $index) {
                <div
                    class="rounded-[10px] border border-malou-primary bg-white px-4 py-4 md:gap-2"
                    [ngClass]="{
                        '!border-0 !bg-white/50': !!aggregatedScoreRating(),
                    }">
                    @switch (scoreCriteria) {
                        @case (ScoreCriteria.INCONSISTENCIES) {
                            <ng-container
                                [ngTemplateOutlet]="scoreDetailsInconsistenciesTemplate"
                                [ngTemplateOutletContext]="{
                                    inconsistenciesDetails:
                                        getRestaurantScoreCriterionDetails
                                        | applyPure: restaurantDiagnosticData.id : ScoreCriteria.INCONSISTENCIES,
                                }"></ng-container>
                        }
                        @case (ScoreCriteria.BETTER_LOCAL_COMPETITORS) {
                            <ng-container
                                [ngTemplateOutlet]="scoreDetailsBetterLocalCompetitorsTemplate"
                                [ngTemplateOutletContext]="{
                                    betterLocalCompetitorsDetails:
                                        getRestaurantScoreCriterionDetails
                                        | applyPure: restaurantDiagnosticData.id : ScoreCriteria.BETTER_LOCAL_COMPETITORS,
                                }"></ng-container>
                        }
                        @case (ScoreCriteria.REVIEW_COUNT) {
                            <ng-container
                                [ngTemplateOutlet]="scoreDetailsReviewCountTemplate"
                                [ngTemplateOutletContext]="{
                                    reviewCountDetails:
                                        getRestaurantScoreCriterionDetails
                                        | applyPure: restaurantDiagnosticData.id : ScoreCriteria.REVIEW_COUNT,
                                }"></ng-container>
                        }
                        @case (ScoreCriteria.INSTAGRAM_VISIBILITY) {
                            <ng-container
                                [ngTemplateOutlet]="scoreDetailsInstagramVisibilityTemplate"
                                [ngTemplateOutletContext]="{
                                    instagramVisibilityDetails:
                                        getRestaurantScoreCriterionDetails
                                        | applyPure: restaurantDiagnosticData.id : ScoreCriteria.INSTAGRAM_VISIBILITY,
                                }"></ng-container>
                        }
                    }
                </div>
            }
        }
    </div>
</ng-template>

<ng-template let-restaurantDiagnosticData="restaurantDiagnosticData" #restaurantScoreTemplate>
    <div class="flex w-full items-center justify-between sm:flex-col sm:gap-2">
        <div class="flex flex-col gap-x-7.5 rounded-[10px] sm:w-full md:gap-2">
            <div class="malou-text-20--bold md:malou-text-14--bold text-malou-text-title">
                {{ restaurantDiagnosticData.restaurantName }}
            </div>
            <div class="malou-text-12--regular md:malou-text-12--regular flex gap-x-4 text-malou-text-title md:flex-col">
                @if (restaurantDiagnosticData.restaurantAddress) {
                    <div class="flex items-center gap-x-2">
                        <mat-icon class="!h-4 !w-4 text-malou-text-title md:!h-3 md:!w-3" [svgIcon]="SvgIcon.LETTER"></mat-icon>
                        <span>{{ restaurantDiagnosticData.restaurantAddress }}</span>
                    </div>
                }
                @if (restaurantDiagnosticData.instagramPage) {
                    <div class="flex items-center gap-x-2">
                        <img
                            class="h-5 w-5 rounded md:h-3 md:w-3"
                            alt="instagram logo"
                            [src]="
                                restaurantDiagnosticData.instagramPageProfile && !instagramImageLoadError()
                                    ? restaurantDiagnosticData.instagramPageProfile
                                    : (PlatformKey.INSTAGRAM | logoPathResolver: { folder: 'platforms' })
                            "
                            (error)="onInstagramImageLoadError()" />
                        <span>{{ '@' + restaurantDiagnosticData.instagramPage }}</span>
                    </div>
                }
            </div>
        </div>
        <div class="flex w-1/3 justify-end sm:w-full sm:items-end sm:justify-center">
            <ng-container
                [ngTemplateOutlet]="scoreRatingTemplate"
                [ngTemplateOutletContext]="{
                    score: restaurantDiagnosticData.totalScore,
                    scoreRating: restaurantDiagnosticData.totalScoreRating,
                    scoreGaugeImage: restaurantDiagnosticData.scoreGaugeImage,
                    isRestaurantScore: true,
                }"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template
    let-score="score"
    let-scoreRating="scoreRating"
    let-scoreGaugeImage="scoreGaugeImage"
    let-isRestaurantScore="isRestaurantScore"
    #scoreRatingTemplate>
    <div
        class="flex h-full items-start justify-center gap-4 md:flex-row"
        [ngClass]="{
            'flex-row sm:flex-col': isPreview(),
            'flex-col': !isPreview() && !isRestaurantScore,
            'w-full pl-16': isPreview() && isRestaurantScore,
        }">
        <div [ngClass]="{ 'w-1/2': isRestaurantScore }">
            <img
                alt="Score gauge"
                inline="true"
                [ngClass]="{ 'h-[63px] w-[72px] md:h-14 md:w-16': isRestaurantScore, 'h-40 w-44 md:h-20 md:w-24': !isRestaurantScore }"
                [src]="scoreGaugeImage | imagePathResolver: { folder: 'score-gauge' }" />
        </div>

        <div class="malou-text-20--regular flex items-baseline text-malou-text-title/70">
            <span
                [ngClass]="{
                    'text-malou-pink': scoreRating === DiagnosticRating.BAD,
                    'text-malou-yellow': scoreRating === DiagnosticRating.AVERAGE,
                    'text-malou-green': scoreRating === DiagnosticRating.GOOD,
                    'malou-text-50--bold md:malou-text-40--bold': !isRestaurantScore || restaurantsDiagnosticsData().length > 3,
                    'malou-text-40--bold md:malou-text-30--bold w-4/5': isRestaurantScore,
                }"
                >{{ score }}</span
            >
            <span class="min-w-fit">/ 100</span>
        </div>
    </div>
</ng-template>

<ng-template #scoreDetailsHeaderTemplate>
    <div
        class="flex items-center gap-x-2 rounded-[10px] border border-malou-primary bg-white px-4 pb-1 pt-1 md:gap-2"
        [ngClass]="{
            '!border-0 !bg-white/20': !!aggregatedScoreRating(),
        }">
        <img class="w-24 md:w-16" alt="Binoculars" [src]="Illustration.BINOCULARS | illustrationPathResolver" />
        <span class="malou-text-18--medium md:malou-text-12--medium text-malou-text-title" id="scoreDetailsHeader">
            @switch (aggregatedScoreRating()) {
                @case (DiagnosticRating.BAD) {
                    <span [innerHTML]="'maloupe.aggregated_diagnostic_score.header.bad_title' | translate"></span>
                }
                @case (DiagnosticRating.AVERAGE) {
                    <span [innerHTML]="'maloupe.aggregated_diagnostic_score.header.average_title' | translate"></span>
                }
                @case (DiagnosticRating.GOOD) {
                    <span [innerHTML]="'maloupe.aggregated_diagnostic_score.header.good_title' | translate"></span>
                }
            }
        </span>
    </div>
</ng-template>

<ng-template let-inconsistenciesDetails="inconsistenciesDetails" #scoreDetailsInconsistenciesTemplate>
    <app-rating-bloc
        [text]="'maloupe.diagnostic_score.inconsistencies.text' | pluralTranslate: inconsistenciesDetails.count"
        [title]="'maloupe.diagnostic_score.inconsistencies.title' | pluralTranslate: inconsistenciesDetails.count"
        [rating]="inconsistenciesDetails.rating"></app-rating-bloc>
</ng-template>

<ng-template let-betterLocalCompetitorsDetails="betterLocalCompetitorsDetails" #scoreDetailsBetterLocalCompetitorsTemplate>
    <app-rating-bloc
        [text]="'maloupe.diagnostic_score.better_local_competitors.text' | pluralTranslate: betterLocalCompetitorsDetails.count"
        [title]="'maloupe.diagnostic_score.better_local_competitors.title' | pluralTranslate: betterLocalCompetitorsDetails.count"
        [rating]="betterLocalCompetitorsDetails.rating"></app-rating-bloc>
</ng-template>

<ng-template let-reviewCountDetails="reviewCountDetails" #scoreDetailsReviewCountTemplate>
    @switch (reviewCountDetails.rating) {
        @case (DiagnosticRating.BAD) {
            @if (reviewCountDetails.count === 0) {
                <app-rating-bloc
                    [text]="'maloupe.diagnostic_score.review_count.no_review_text' | translate"
                    [title]="'maloupe.diagnostic_score.review_count.title.no_reviews' | translate"
                    [rating]="reviewCountDetails.rating"></app-rating-bloc>
            } @else {
                <app-rating-bloc
                    [text]="'maloupe.diagnostic_score.review_count.text' | translate"
                    [title]="'maloupe.diagnostic_score.review_count.title.bad' | translate: { reviewCountDiff: reviewCountDetails.diff }"
                    [rating]="reviewCountDetails.rating"></app-rating-bloc>
            }
        }
        @case (DiagnosticRating.AVERAGE) {
            <app-rating-bloc
                [text]="'maloupe.diagnostic_score.review_count.text' | translate"
                [title]="'maloupe.diagnostic_score.review_count.title.average' | translate: { reviewCountDiff: reviewCountDetails.diff }"
                [rating]="reviewCountDetails.rating"></app-rating-bloc>
        }
        @case (DiagnosticRating.GOOD) {
            <app-rating-bloc
                [text]="'maloupe.diagnostic_score.review_count.text' | translate"
                [title]="'maloupe.diagnostic_score.review_count.title.good' | translate"
                [rating]="reviewCountDetails.rating"></app-rating-bloc>
        }
    }
</ng-template>

<ng-template let-instagramVisibilityDetails="instagramVisibilityDetails" #scoreDetailsInstagramVisibilityTemplate>
    @if (instagramVisibilityDetails.hasInstagram) {
        @switch (instagramVisibilityDetails.rating) {
            @case (DiagnosticRating.BAD) {
                <app-rating-bloc
                    [text]="'maloupe.diagnostic_score.instagram_visibility.text.bad' | translate"
                    [title]="'maloupe.diagnostic_score.instagram_visibility.title.bad' | translate"
                    [rating]="instagramVisibilityDetails.rating"></app-rating-bloc>
            }
            @case (DiagnosticRating.AVERAGE) {
                <app-rating-bloc
                    [text]="'maloupe.diagnostic_score.instagram_visibility.text.average' | translate"
                    [title]="'maloupe.diagnostic_score.instagram_visibility.title.average' | translate"
                    [rating]="instagramVisibilityDetails.rating"></app-rating-bloc>
            }
            @case (DiagnosticRating.GOOD) {
                <app-rating-bloc
                    [text]="'maloupe.diagnostic_score.instagram_visibility.text.good' | translate"
                    [title]="'maloupe.diagnostic_score.instagram_visibility.title.good' | translate"
                    [rating]="instagramVisibilityDetails.rating"></app-rating-bloc>
            }
        }
    }
</ng-template>
